module.exports = __webpack_public_path__ + "fonts/helvetica-now-display-medium.030c747.woff2";